import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

import { CATEGORIAS_ENDERECO_EXPOSICAO, STATUS_ATIVO } from '../../utils';

const choicesCategoria = CATEGORIAS_ENDERECO_EXPOSICAO.map((c) => ({
  id: c.categoria,
  name: c.label,
}));

const choicesExposicao = [
  { id: 'nao-exposto', name: 'Não Exposto' },
  { id: 'unica', name: 'Única' },
  { id: 'duplicada', name: 'Duplicado' },
  { id: 'triplicada', name: 'Triplicado' },
  { id: 'mais-de-3', name: 'Mais de 3' },
];

const choicesTerreoExposicao = [
  { id: true, name: 'Sim' },
  { id: false, name: 'Não' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    <ReferenceInput
      fullWidth
      label="Produto"
      source="produto_id"
      reference="produtos_search_filter"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <SelectInput
      source="exposicao"
      choices={choicesExposicao}
      label="Exposição"
      allowEmpty={false}
    />
    <SelectInput
      source="terreo_exposicao"
      choices={choicesTerreoExposicao}
      label="Térreo é exposição em loja?"
      allowEmpty={false}
    />
    <SelectInput
      source="categoria"
      choices={choicesCategoria}
      label="Categoria"
      allowEmpty={false}
    />
    <ReferenceInput
      fullWidth
      label="Mapa"
      source="mapa_loja_id"
      reference="mapas_loja"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
